import { computed } from 'vue'
// types
import type { UseBtnSecondaryOptions, UseBtnSecondaryReturn } from '../types/interfaces'

export const useBtnSecondary = ({ props, onClick }: UseBtnSecondaryOptions): UseBtnSecondaryReturn => {
  const classList = computed<(string | Record<string, boolean>)[]>(() => [
    'ui-btn-secondary',
    `ui-btn-secondary--${props.color}`,
    `ui-btn-secondary--${props.size}`,
    `ui-btn-secondary--${props.elementWidth}`,
    { 'ui-btn-secondary--selected': Boolean(props.selected) },
  ])

  const handleClick = (): void => {
    onClick()
  }

  return {
    classList,
    handleClick,
  }
}